/**
 * Store V2 cache epoch — staging R2C default; production build overrides via Vite env.
 */

export const STORE_V2_CACHE_EPOCH =
  (import.meta.env.VITE_STORE_CACHE_EPOCH as string | undefined)?.trim() ||
  "COMMERCE_LAUNCH_163A_R2C_RC1_20260804";
export const COMMERCE_LAUNCH_163A_R2C_RC1_MARKER =
  (import.meta.env.VITE_BUILD_ID as string | undefined)?.trim() ||
  "COMMERCE-LAUNCH-163A-R2C-RC1";
/** @deprecated alias — prefer COMMERCE_LAUNCH_163A_R2C_RC1_MARKER / VITE_BUILD_ID */
export const COMMERCE_CANARY_163A_R2B_HARD_RESTORE_MARKER = COMMERCE_LAUNCH_163A_R2C_RC1_MARKER;
export const COMMERCE_LAUNCH_163A_R2C_RC1_MARKER_ALIAS = COMMERCE_LAUNCH_163A_R2C_RC1_MARKER;

const EPOCH_KEY = "asiastyle.store-v2.cache-epoch.v1";

const CUSTOMER_BOUND_PREFIXES = [
  "asiastyle.store-v2.checkout-prefill.v1",
  "asiastyle.store-v2.address-book.v1",
  "asiastyle.store-v2.consent.v1",
  "asiastyle.store-v2.session.v1",
  "asiastyle.store-v2.cart.v1",
  "asiastyle.store-v2.promo.v1",
  "asiastyle.store-v2.np-checkout-draft.v1",
  "asiastyle.store-v2.identity-scope.v1",
  "asiastyle.store-v2.orders",
  "asiastyle.store-v2.order-list",
  "asiastyle.store-v2.payment-resume",
  "asiastyle.store-v2.checkout-attempt.v1",
];

function clearStorageByPrefixes(storage: Storage, prefixes: string[]): void {
  const toRemove: string[] = [];
  for (let i = 0; i < storage.length; i += 1) {
    const k = storage.key(i);
    if (!k) continue;
    if (prefixes.some((p) => k.startsWith(p))) toRemove.push(k);
  }
  for (const k of toRemove) storage.removeItem(k);
}

function isStagingHost(): boolean {
  try {
    const h = window.location.hostname.toLowerCase();
    return (
      h.includes("asiastyle-mini-app.pages.dev") ||
      h.includes("localhost") ||
      h.includes("127.0.0.1")
    );
  } catch {
    return false;
  }
}

/**
 * One-shot epoch bump for staging Store. Safe to call on every boot.
 * Never clears catalog assets; never loops (writes new epoch immediately).
 */
export function ensureStoreV2CacheEpoch(): { cleared: boolean; epoch: string } {
  if (typeof window === "undefined" || !isStagingHost()) {
    return { cleared: false, epoch: STORE_V2_CACHE_EPOCH };
  }
  try {
    const prev = window.localStorage.getItem(EPOCH_KEY);
    if (prev === STORE_V2_CACHE_EPOCH) {
      return { cleared: false, epoch: STORE_V2_CACHE_EPOCH };
    }
    clearStorageByPrefixes(window.localStorage, CUSTOMER_BOUND_PREFIXES);
    clearStorageByPrefixes(window.sessionStorage, CUSTOMER_BOUND_PREFIXES);
    window.localStorage.setItem(EPOCH_KEY, STORE_V2_CACHE_EPOCH);
    return { cleared: true, epoch: STORE_V2_CACHE_EPOCH };
  } catch {
    return { cleared: false, epoch: STORE_V2_CACHE_EPOCH };
  }
}
